import { useState } from "react"
import { useCustomerUserQuery } from "@/v2-backoffice-client/customer/user/customer.user.query"
import { useLicenseSeatHoldersQuery } from "@/v2-backoffice-client/license/seats/license.seats.holders.query"
import CustomerUserTable, {
  type CustomerUserTableProps,
} from "@/v2-backoffice-client/customer/user/CustomerUserTable"

export type CustomerUserProps = Omit<
  CustomerUserTableProps,
  "users" | "onRefresh" | "isLoading" | "error" | "onDeletedFilterChange"
> & {
  customerId: number
}

function CustomerUser(props: CustomerUserProps) {
  const { customerId, ...customerUserTableProps } = props

  const [onlyDeleted, setOnlyDeleted] = useState<boolean | undefined>(false)

  const { data, loading, error, refetch } = useCustomerUserQuery({
    variables: { customerId, onlyDeleted },
  })

  // Who holds a seat on the customer's seated licenses, shown beside the
  // person (the same read the Licensing tab groups per license).
  const { data: seatHoldersData } = useLicenseSeatHoldersQuery({
    variables: { customerId },
  })

  const users = data?.getCustomerUsers || []

  return (
    <CustomerUserTable
      users={users}
      isLoading={loading}
      error={error}
      seatHolders={seatHoldersData?.getLicenseSeatHolders}
      onDeletedFilterChange={setOnlyDeleted}
      onRefresh={refetch}
      {...customerUserTableProps}
    />
  )
}

export default CustomerUser
